<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/receipt-order";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Receipt Orders",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('receipt_orders.singular')) }},
    resourceRoute: {default: 'receipt_orders'},
    modelVariable: {default: 'receipt_order'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
          href: "/receipt_orders",
        },
        {
          text: this.$t("Create New"),
          href: "/receipt_orders/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/receipt_orders', value);
    }
  }
}
</script>
